import { SearchOutlined } from "@ant-design/icons";
import { Input, Table } from "antd";
import "antd/dist/antd.css";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import useSWR from "swr";
import { itemRender, onShowSizeChange } from "../../../paginationfunction";
import NotFoundPage from "../../StoreComponents/NotFoundPage";
import { API } from "../../StoreComponents/conflict";
import useGetData from "../../StoreComponents/hooks/useGetData";
import { PostStoreLog } from "../../StoreComponents/hooks/useStoreLog";
const fetcher = (url) => API.get(url).then((res) => res.data.data);

const RequestProduct = () => {
  const logInStatus = parseInt(Cookies.get("Role"));
  // console.log(logInStatus)
  const [search, setSearch] = useState("");
  const [singleData, setSingleData] = useState();
  const [singleDataId, setSingleDataID] = useState();
  const [openElement, setOpenElement] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const { CountData } = useGetData();
  const { mutate: mutate1 } = CountData();
  const {
    data: dataSource,
    error,
    mutate,
  } = useSWR(`store/requisition/product/request/admin`, fetcher);
  console.log(dataSource);
  console.log(singleData);

  const columns = [
    {
      title: "ID",
      className: "dark_bg ",
      dataIndex: "REQUEST_ID",
    },
    {
      title: "Date",
      className: "dark_bg ",
      render: (text, record) => <td>{record.REQUEST_DATE.split("T")[0]}</td>,
    },
    {
      title: "Employee Name",
      className: "dark_bg ",
      render: (text, record) => (
        <div className="text-start">
          <td>{record.NAME_ENGLISH}</td>
        </div>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
            <Input
              autoFocus
              placeholder="Type Employee name here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </div>
        );
      },
      filterIcon: () => {
        return (
          <SearchOutlined className="text-black bg-white fs-6 rounded-pill p-1" />
        );
      },
      onFilter: (value, record) => {
        return record.NAME_ENGLISH.toLowerCase().includes(value.toLowerCase());
      },
    },

    {
      title: "Designation",
      className: "dark_bg ",
      dataIndex: "DESIGNATION",
    },
    {
      title: "Department",
      className: "dark_bg ",
      dataIndex: "DEPARTEMENT",
    },
    {
      title: "Request ",
      className: "dark_bg text-center",
      dataIndex: "TOTAL_REQUEST_QTY",
    },
    {
      title: "Approved ",
      className: "dark_bg text-center",
      dataIndex: "TOTAL_APPROVED_QTY",
    },
    {
      title: "Status",
      className: "dark_bg text-center",
      render: (text, record) => (
        <td className="text-center pt-2">
          <span className="bg-success text-white px-3 py-1 rounded-3">
            {record.REQUEST_STATUS === 1
              ? "Approved"
              : record.REQUEST_STATUS === 2
                ? "Checked"
                : record.REQUEST_STATUS === 3
                  ? "Not Approved"
                  : "Pending"}
          </span>
        </td>
      ),
    },

    {
      title: "Action",
      className: "dark_bg ",
      render: (text, record) =>
        logInStatus === 5 ? (
          <>
            <td className="">
              {record.REQUEST_STATUS === 0 && (
                <Link
                  to={`/requisitions/requestProduct/viewPendingRequest/${record.REQUEST_ID}`}
                >
                  <button
                    className="fs-6  bg-danger"
                    style={{
                      color: "#fff",
                      borderRadius: "10px",
                    }}
                  >
                    <i class="fa fa-check m-r-5"></i>
                    Approve
                  </button>
                </Link>
              )}
              <Link
                to={`/requisition/requestProduct/slip/${record.REQUEST_ID}`}
              >
                <button
                  className="fs-6 ms-1"
                  style={{
                    backgroundColor: "#3C8DBC",
                    color: "#fff",
                    borderRadius: "10px",
                  }}
                >
                  <i className="fa fa-eye m-r-5" /> View
                </button>
              </Link>
            </td>
          </>
        ) : (
          logInStatus === 24 && (
            <div className="dropdown dropdown-action text-right">
              <a
                href="#"
                className="action-icon dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-icons">more_vert</i>
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  to={`/requisition/requestProduct/slip/${record.REQUEST_ID}`}
                >
                  <a className="dropdown-item" data-toggle="modal">
                    <i className="fa fa-eye m-r-5" /> View
                  </a>
                </Link>
                {record.REQUEST_STATUS === 1 && (
                  <a
                    className="dropdown-item"
                    href="#"
                    data-toggle="modal"
                    data-target="#edit_status"
                    onClick={() => {
                      setSingleData(record.ARRAYDATA);
                      setSingleDataID(record.REQUEST_ID);
                    }}
                  >
                    <i class="fa fa-pencil m-r-5"></i> Check Out
                  </a>
                )}
              </div>
            </div>
          )
        ),
    },
  ];

  // console.log(error);
  // react hook form
  const { register, handleSubmit, reset } = useForm();
  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();

  const updateProduct = (id, value, name) => {
    console.log(id, value, name, singleData);
    return singleData.map((item, index) => {
      let myItem = item;
      // setProId(id);

      if (item.PRODUCT_CODE === parseInt(id)) {
        myItem[name] = value;
      }
    });
  };

  //  Update Status
  const onSubmitUpdate = () => {
    const data = {
      REQUEST_ID: parseInt(singleDataId),
      products: singleData,
      status: 2,
    };
    console.log(data);
    setButtonLoading(true);
    API.put("store/requisition/product/request/storeOficer", data).then(
      (res) => {
        console.log(res);

        if (!res.data.error) {
          swal({
            title: "Thank You !",
            text: "Successfully Added",
            icon: "success",
            button: "Ok",
          });
          PostStoreLog(2, "Request Product Status checked");
          setButtonLoading(false);
          reset();
          window.$("#edit_status").modal("hide");
          mutate();
          mutate1();
        } else {
          swal({
            title: "Opps !",
            text: `${res.data.message}`,
            icon: "warning",
            button: "Ok",
          });
          reset();
          mutate();
          setButtonLoading(false);
        }
      }
    );
  };

  return (
    <>
      <Helmet>
        <title>Request Product - BBA STORE</title>
        <meta name="description" content="Request Product - BBA STORE" />
      </Helmet>

      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
            <h3 className="text-start text-dark">Manage Request Product</h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            {!dataSource ? (
              <NotFoundPage />
            ) : (
              <div className="row ">
                <div className="col-md-12 ">
                  <div className="table-responsive">
                    <Table
                      className="table-striped"
                      pagination={{
                        total:
                          dataSource === undefined ? 0 : dataSource.info.length,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        showSizeChanger: true,
                        onShowSizeChange: onShowSizeChange,
                        itemRender: itemRender,
                      }}
                      style={{ overflowX: "auto" }}
                      columns={columns}
                      // bordered
                      dataSource={
                        dataSource === undefined ? [] : dataSource.info
                      }
                      rowKey={(record) => record.UNIT_ID}
                      onChange={console.log("change")}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div id="edit_status" className="modal custom-modal fade" role="dialog">
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update </h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body text-start">
              <form onSubmit={handleSubmit(onSubmitUpdate)}>
                <div className="col-12 col-md-12 col-lg-12 text-center mt-5">
                  <div className="mt-3">
                    <div className="table-responsive-sm data-table">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr
                            style={{
                              backgroundColor: "#3C8DBC",
                              color: "white",
                              textAlign: "center",
                            }}
                            className="text-white text-center"
                          >
                            <th colSpan="1">S/N </th>
                            <th colSpan="2">Products</th>
                            <th colSpan="1">Required</th>
                            <th colSpan="2">Approved</th>
                            <th colSpan="2">Comments </th>
                            <th colSpan="2">Admin Remarks</th>
                            <th colSpan="2">Store Remarks</th>
                          </tr>
                        </thead>
                        {/* productArray */}
                        <tbody>
                          {singleData &&
                            singleData?.map((product, index) => (
                              <tr key={index}>
                                <td colSpan="1" className="text-center">
                                  {++index}
                                </td>
                                <td colSpan="2">{product.PRODUCT_NAME} </td>
                                <td colSpan="1">{product.REQUEST_QTY}</td>

                                <td colSpan="2">{product.APPROVED_QTY}</td>
                                <td colSpan="2">
                                  <textarea
                                    type="text"
                                    style={{
                                      width: "100%",
                                      height: "70px",
                                      paddingLeft: "5px",
                                    }}
                                    className="input-field-new"
                                    placeholder={product.REQUEST_REMARKS}
                                    disabled
                                  />
                                </td>
                                <td colSpan="2">
                                  <textarea
                                    type="text"
                                    disabled
                                    style={{
                                      width: "100%",
                                      height: "70px",
                                      paddingLeft: "5px",
                                    }}
                                    className="input-field-new"
                                  />
                                </td>
                                <td colSpan="2">
                                  <textarea
                                    type="text"
                                    style={{
                                      width: "100%",
                                      height: "70px",
                                      paddingLeft: "5px",
                                    }}
                                    className="input-field-new"
                                    onChange={(e) => {
                                      updateProduct(
                                        product.PRODUCT_CODE,
                                        e.target.value,
                                        "STORE_REMARK"
                                      );
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="submit-section">
                  <button
                    type="submit"
                    className="btn btn-color_store text-white px-5 py-2 rounded"
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-color_store text-white px-5 ms-1 py-2 rounded"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestProduct;
